const targetSectionRefs1 = document.querySelectorAll('section.detail-cards-new--js');

if (targetSectionRefs1.length) {
  targetSectionRefs1.forEach(targetSectionElement => {
    let clickCount = 1;

    const fraction = document.createElement('div');
    fraction.classList.add('fraction');
    
    const customHolder = targetSectionElement.querySelector('.swiper-pagination--custom-holder');
    if (customHolder) {
      customHolder.appendChild(fraction);
    }

    const swiperElement = targetSectionElement.querySelector('.swiper');
    
    if (swiperElement) {
      const swiper = new Swiper(swiperElement, {
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        watchOverflow: true,
        breakpoints: {
          1641: {
            spaceBetween: 30
          }
        }
      });

      swiper.on('slideChange', () => {
        updateFraction(swiper, fraction);
        updateLockClass(swiper, targetSectionElement);
      });
      swiper.on('init', () => {
        updateFraction(swiper, fraction);
        updateLockClass(swiper, targetSectionElement);
      });

      swiper.init();
      updateFraction(swiper, fraction);
      updateLockClass(swiper, targetSectionElement);

      function updateFraction(swiper, fraction) {
        const activeSlides = Array.from(swiper.slides);
        const activeSlideCount = activeSlides.length;
        let actualSlidesPerView = getActualSlidesPerView(swiper);

        const result = Math.round(activeSlideCount - actualSlidesPerView);
        const currentIndex = swiper.realIndex + 1;
      
        if (currentIndex > result) {
          fraction.textContent = `${result} / ${result}`;
        } else {
          fraction.textContent = `${currentIndex} / ${result}`;
        }
      }

      function getActualSlidesPerView(swiper) {
        const swiperWidth = swiper.width;
        const slides = swiper.slides;
        let totalSlidesWidth = 0;
        let slidesPerView = 0;
      
        for (let i = 0; i < slides.length; i++) {
          totalSlidesWidth += slides[i].offsetWidth + parseFloat(getComputedStyle(slides[i]).marginRight);
      
          if (totalSlidesWidth > swiperWidth) {
            break;
          }
          
          slidesPerView++;
        }
        return slidesPerView;
      }

      function updateLockClass(swiper, targetSectionElement) {
        const prevButton = targetSectionElement.querySelector('.swiper-button-prev');
        const nextButton = targetSectionElement.querySelector('.swiper-button-next');
        const swiperElement = targetSectionElement.querySelector('.swiper');
  
        if (prevButton.classList.contains('swiper-button-lock') || nextButton.classList.contains('swiper-button-lock')) {
          swiperElement.classList.add('swiper--lock');
        } else {
          swiperElement.classList.remove('swiper--lock');
        }
      }

      const prevButton = targetSectionElement.querySelector('.swiper-button-prev');
      const nextButton = targetSectionElement.querySelector('.swiper-button-next');

      prevButton.addEventListener('click', () => {
        // swiper.slidePrev();
        clickCount--;
        updateFraction(swiper, fraction);
      });

      nextButton.addEventListener('click', () => {
        // swiper.slideNext();
        clickCount++;
        updateFraction(swiper, fraction);
      });
    }
  });
}

const targetSectionSlider = document.querySelectorAll('section.slider-images');

if (targetSectionSlider.length) {
  targetSectionSlider.forEach(targetSectionElement => {
    let clickCount = 1;

    const fraction = document.createElement('div');
    fraction.classList.add('fraction');
    
    const customHolder = targetSectionElement.querySelector('.swiper-pagination--custom-holder');
    if (customHolder) {
      customHolder.appendChild(fraction);
    }

    const swiperElement = targetSectionElement.querySelector('.swiper');
    
    if (swiperElement) {
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 20,
        slidesPerGroup: 1,
        slidesToScroll: 1,
        navigation: {
          prevEl: ".slider-images .swiper-button-prev",
          nextEl: ".slider-images .swiper-button-next",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        watchOverflow: true,
        breakpoints: {
          1700: {
            slidesPerView: 4.6
          },
          1200: {
            slidesPerView: 3.6
          },
          750: {
            slidesPerView: 2
          }
        },
      });

      function copySlides() {
        const slides = swiperElement.querySelectorAll('.slide-without-popup');

        swiper.params.centeredSlides = true;
        swiper.update();
        swiper.slideTo(2);

        slides.forEach(slide => {
          swiper.appendSlide(slide.cloneNode(true));
        });
        
      }
      copySlides();

      swiper.on('slideChange', () => {
        updateFraction(swiper, fraction);
        updateLockClass(swiper, targetSectionElement);
      });
      swiper.on('init', () => {
        updateFraction(swiper, fraction);
        updateLockClass(swiper, targetSectionElement);
      });

      swiper.init();
      updateFraction(swiper, fraction);
      updateLockClass(swiper, targetSectionElement);

      function updateFraction(swiper, fraction) {
        const activeSlides = Array.from(swiper.slides);
        const activeSlideCount = activeSlides.length;
        let actualSlidesPerView = getActualSlidesPerView(swiper);

        const result = Math.round(activeSlideCount - actualSlidesPerView);
        const currentIndex = swiper.realIndex + 1;
      
        if (currentIndex > result) {
          fraction.textContent = `${result} / ${result}`;
        } else {
          fraction.textContent = `${currentIndex} / ${result}`;
        }
      }

      function getActualSlidesPerView(swiper) {
        const swiperWidth = swiper.width;
        const slides = swiper.slides;
        let totalSlidesWidth = 0;
        let slidesPerView = 0;
      
        for (let i = 0; i < slides.length; i++) {
          totalSlidesWidth += slides[i].offsetWidth + parseFloat(getComputedStyle(slides[i]).marginRight);
      
          if (totalSlidesWidth > swiperWidth) {
            break;
          }
          
          slidesPerView++;
        }
        return slidesPerView;
      }

      function updateLockClass(swiper, targetSectionElement) {
        const prevButton = targetSectionElement.querySelector('.swiper-button-prev');
        const nextButton = targetSectionElement.querySelector('.swiper-button-next');
        const swiperElement = targetSectionElement.querySelector('.swiper');
  
        if (prevButton.classList.contains('swiper-button-lock') || nextButton.classList.contains('swiper-button-lock')) {
          swiperElement.classList.add('swiper--lock');
        } else {
          swiperElement.classList.remove('swiper--lock');
        }
      }

      const prevButton = targetSectionElement.querySelector('.swiper-button-prev');
      const nextButton = targetSectionElement.querySelector('.swiper-button-next');

      prevButton.addEventListener('click', () => {
        swiper.slidePrev();
        clickCount--;
        updateFraction(swiper, fraction);
      });

      nextButton.addEventListener('click', () => {
        swiper.slideNext();
        clickCount++;
        updateFraction(swiper, fraction);
      });
    }
  });
}

const targetSectionSliderVSQ = document.querySelectorAll('section.vsq-set--cardsSection');

if (targetSectionSliderVSQ.length) {
  targetSectionSliderVSQ.forEach(targetSectionElement => {
    let clickCount = 1;

    const fraction = document.createElement('div');
    fraction.classList.add('fraction');
    
    const customHolder = targetSectionElement.querySelector('.swiper-pagination--custom-holder');
    if (customHolder) {
      customHolder.appendChild(fraction);
    }

    const swiperElement = targetSectionElement.querySelector('.swiper');
    
    if (swiperElement) {
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 20,
        slidesToScroll: 1,
        navigation: {
          prevEl: ".slider-images .swiper-button-prev",
          nextEl: ".slider-images .swiper-button-next",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        watchOverflow: true,
        breakpoints: {
          1200: {
            slidesPerView: 4
          },
          992: {
            slidesPerView: 3
          },
          750: {
            slidesPerView: 2
          }
        },
      });

      swiper.on('slideChange', () => {
        updateFraction(swiper, fraction);
        updateLockClass(swiper, targetSectionElement);
      });
      swiper.on('init', () => {
        updateFraction(swiper, fraction);
        updateLockClass(swiper, targetSectionElement);
      });

      swiper.init();
      updateFraction(swiper, fraction);
      updateLockClass(swiper, targetSectionElement);

      function updateFraction(swiper, fraction) {
        const activeSlides = Array.from(swiper.slides);
        const activeSlideCount = activeSlides.length;
        let actualSlidesPerView = getActualSlidesPerView(swiper);

        const result = Math.round(activeSlideCount - actualSlidesPerView);
        const currentIndex = swiper.realIndex + 1;
      
        if (currentIndex > result) {
          fraction.textContent = `${result} / ${result}`;
        } else {
          fraction.textContent = `${currentIndex} / ${result}`;
        }
      }

      function getActualSlidesPerView(swiper) {
        const swiperWidth = swiper.width;
        const slides = swiper.slides;
        let totalSlidesWidth = 0;
        let slidesPerView = 0;
      
        for (let i = 0; i < slides.length; i++) {
          totalSlidesWidth += slides[i].offsetWidth + parseFloat(getComputedStyle(slides[i]).marginRight);
      
          if (totalSlidesWidth > swiperWidth) {
            break;
          }
          
          slidesPerView++;
        }
        return slidesPerView;
      }

      function updateLockClass(swiper, targetSectionElement) {
        const prevButton = targetSectionElement.querySelector('.swiper-button-prev');
        const nextButton = targetSectionElement.querySelector('.swiper-button-next');
        const swiperElement = targetSectionElement.querySelector('.swiper');
  
        if (prevButton.classList.contains('swiper-button-lock') || nextButton.classList.contains('swiper-button-lock')) {
          swiperElement.classList.add('swiper--lock');
        } else {
          swiperElement.classList.remove('swiper--lock');
        }
      }

      const prevButton = targetSectionElement.querySelector('.swiper-button-prev');
      const nextButton = targetSectionElement.querySelector('.swiper-button-next');

      prevButton.addEventListener('click', () => {
        swiper.slidePrev();
        clickCount--;
        updateFraction(swiper, fraction);
      });

      nextButton.addEventListener('click', () => {
        swiper.slideNext();
        clickCount++;
        updateFraction(swiper, fraction);
      });
    }
  });
}

const openModalContainer = document.querySelectorAll('.slide-with-popup');
const closeModalButtons1 = document.querySelectorAll('.modal-btn-close');
const modals1 = document.querySelectorAll('.card-modal-content');
const detailCardSection = document.querySelector('.detail-cards--section'); // add modal at the end of section to save styles
const videoBlock = document.querySelectorAll('.modal-video--box'); // for autoplay video inside the cards
const svxCardSection = document.querySelector('.detail-cards--section.svx-landing');
const svxAnchorButtons = svxCardSection?.querySelectorAll('.svx-landing-btn');
const body = document.body;

const modalCache = {};

modals1.forEach(modal => {
  modalCache[modal.id] = modal;
  modal.remove();
});

let currentModal1 = null;
let currentNavResizeHandler = null;
let swipeHandlers = null;

function createNavBtn(dir, onClick) {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = `modal-nav-btn modal-nav-${dir}`;
  btn.setAttribute('aria-label', `${dir === 'prev' ? 'Previous' : 'Next'} slide`);
  btn.innerHTML = `<span><svg viewBox="0 0 1024 1024"><path d="${dir === 'prev' ? 'M688 224 656 192 336 512 336 512 320 528 656 864 688 832 384 528Z' : 'M672 512 672 512 352 192 320 224 624 528 320 832 352 864 688 528Z'}"/></svg></span>`;
  btn.onclick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };
  return btn;
}

function positionModalNavButtons(modal) {
  const prevBtn = document.querySelector('.modal-nav-prev');
  const nextBtn = document.querySelector('.modal-nav-next');
  if (!prevBtn && !nextBtn) return;

  const holder = modal.querySelector('.card-modal--holder');
  if (!holder) return;

  const rect = holder.getBoundingClientRect();
  const winWidth = window.innerWidth;
  const btnWidth = winWidth <= 749 ? 36 : 42;
  const gap = winWidth <= 749 ? 10 : 20;

  if (rect.left >= btnWidth + gap + 10) {
    if (prevBtn) prevBtn.style.left = `${rect.left - btnWidth - gap}px`;
    if (nextBtn) nextBtn.style.left = `${rect.right + gap}px`;
  } else {
    if (prevBtn) prevBtn.style.left = `10px`;
    if (nextBtn) nextBtn.style.left = `${winWidth - btnWidth - 10}px`;
  }
}

function updateModalNav(modal, currentCard) {
  if (currentNavResizeHandler) {
    window.removeEventListener('resize', currentNavResizeHandler);
    currentNavResizeHandler = null;
  }
  document.querySelectorAll('.modal-nav-btn').forEach(btn => btn.remove());
  if (!modal || !currentCard) return;

  const section = currentCard.closest('.detail-cards--section');
  const cards = section ? Array.from(section.querySelectorAll('.slide-with-popup[data-target]')) : [];
  const index = cards.indexOf(currentCard);
  const holder = modal.querySelector('.card-modal--holder');

  if (!holder || cards.length <= 1 || index < 0) return;

  const prevBtn = index > 0 ? createNavBtn('prev', () => { closeModal(modal); cards[index - 1].click(); }) : null;
  const nextBtn = index < cards.length - 1 ? createNavBtn('next', () => { closeModal(modal); cards[index + 1].click(); }) : null;

  if (prevBtn) body.appendChild(prevBtn);
  if (nextBtn) body.appendChild(nextBtn);

  positionModalNavButtons(modal);
  requestAnimationFrame(() => positionModalNavButtons(modal));

  currentNavResizeHandler = () => positionModalNavButtons(modal);
  window.addEventListener('resize', currentNavResizeHandler);
}

function attachSwipeListeners(modal, currentCard) {
  detachSwipeListeners();
  const section = currentCard.closest('.detail-cards--section');
  const cards = section ? Array.from(section.querySelectorAll('.slide-with-popup[data-target]')) : [];
  const idx = cards.indexOf(currentCard);
  if (cards.length <= 1 || idx < 0) return;

  const holder = modal.querySelector('.card-modal--holder');
  if (!holder) return;

  let startX, startY, dx, dir;

  const onStart = (e) => { startX = e.touches[0].clientX; startY = e.touches[0].clientY; dx = 0; dir = null; holder.style.transition = 'none'; };

  const onMove = (e) => {
    const mx = e.touches[0].clientX - startX, my = e.touches[0].clientY - startY;
    if (!dir) { if (Math.abs(mx) < 10 && Math.abs(my) < 10) return; dir = Math.abs(mx) > Math.abs(my) ? 'h' : 'v'; }
    if (dir !== 'h') return;
    dx = (mx < 0 && idx >= cards.length - 1) || (mx > 0 && idx <= 0) ? mx * 0.2 : mx;
    e.preventDefault();
    holder.style.transform = `translateX(${dx}px)`;
  };

  const onEnd = (e) => {
    if (dir === 'h') {
      e.preventDefault();
      holder.style.transition = 'transform 0.25s ease-out';
      if (dx < -50 && idx < cards.length - 1) { holder.style.transform = `translateX(-${window.innerWidth}px)`; setTimeout(() => { closeModal(modal); cards[idx + 1].click(); }, 200); }
      else if (dx > 50 && idx > 0) { holder.style.transform = `translateX(${window.innerWidth}px)`; setTimeout(() => { closeModal(modal); cards[idx - 1].click(); }, 200); }
      else { holder.style.transform = 'translateX(0)'; }
    }
  };

  modal.addEventListener('touchstart', onStart, { passive: true });
  modal.addEventListener('touchmove', onMove, { passive: false });
  modal.addEventListener('touchend', onEnd, { passive: false });
  swipeHandlers = { modal, onStart, onMove, onEnd };
}

function detachSwipeListeners() {
  if (!swipeHandlers) return;
  const { modal, onStart, onMove, onEnd } = swipeHandlers;
  modal.removeEventListener('touchstart', onStart);
  modal.removeEventListener('touchmove', onMove);
  modal.removeEventListener('touchend', onEnd);
  swipeHandlers = null;
}

function openModal(modal, currentCard) {
  detailCardSection.appendChild(modal); // rendering a popup only if user clicked on card
  const h = modal.querySelector('.card-modal--holder'); if (h) { h.style.transform = ''; h.style.transition = ''; }
  modal.classList.add('active');
  body.classList.add('no-scroll');
  currentModal1 = modal;

  updateModalNav(modal, currentCard);
  attachSwipeListeners(modal, currentCard);

  // for autoplay video inside the cards
  videoBlock.forEach(element => {
    const video = element.querySelector('video');
    video.play();
  });
}

function closeModal(modal) {
  modal.classList.remove('active');
  body.classList.remove('no-scroll');
  if (currentNavResizeHandler) {
    window.removeEventListener('resize', currentNavResizeHandler);
    currentNavResizeHandler = null;
  }
  document.querySelectorAll('.modal-nav-btn').forEach(btn => btn.remove());
  detachSwipeListeners();
  modal.remove();
  currentModal1 = null;
}

openModalContainer.forEach(button => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    const modalId = button.getAttribute('data-target').replace('#', '');
    const targetModal = modalCache[modalId];
    if (targetModal) {
      openModal(targetModal, button);
    }
  });
});

closeModalButtons1.forEach(button => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    if (currentModal1) {
      closeModal(currentModal1);
    }
  });
});
modals1.forEach(modal => {
  let wideCard = modal.querySelector('.wide-card-container');
  let wideCardSecond = modal.querySelector('.wide-row--block');

  if (wideCard || wideCardSecond) {
    modal.classList.add('wide__card')
  }

  modal.addEventListener('click', (event) => {
    event.stopPropagation();
    if (currentModal1) {
      closeModal(currentModal1);
    }
  });
});

document.addEventListener('click', (event) => {
  if (currentModal1 && !currentModal1.contains(event.target)) {
    closeModal(currentModal1);
  }
});

document.querySelectorAll('.wide-card-container').forEach((element) => {
  const closestHolder = element.closest('.card-modal--holder');
  if (closestHolder) {
      closestHolder.classList.add('full-width');
  }
});

svxAnchorButtons?.forEach(button => {
  button.addEventListener('click', () => {
    document.querySelector('.section-collections-card-slider.svx-landing')
      .scrollIntoView({ behavior: "smooth", block: "end"});
  });
});